import React, { useState, useEffect } from 'react';
import { getMediaCoverage } from '../services/api';

const MediaCoverage = () => {
  const [mediaCoverage, setMediaCoverage] = useState({
    mediaLogos: [],
    videoSection: {}
  });

  useEffect(() => {
    getMediaCoverage().then(data => {
      if (data) {
        setMediaCoverage(data);
      }
    });
  }, []);

  const { mediaLogos = [], videoSection = {} } = mediaCoverage;

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">MEDIA COVERAGE</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2">
            MetroBrix in the Spotlight
          </h2>
          <p className="text-gray-500 mt-2">Latest News & Media Coverage</p>
        </div>

        <div className="flex flex-wrap justify-center gap-4">
          {mediaLogos.map((media, idx) => (
            <div
              key={idx}
              className={`${media.bg} px-8 py-4 rounded-xl flex items-center justify-center cursor-pointer hover:shadow-md transition-shadow min-w-[180px]`}
            >
              <span className={`font-bold text-lg ${media.color}`}>{media.name}</span>
            </div>
          ))}
        </div>

        {/* MetroBrix Speaks */}
        {videoSection.title && (
          <div className="mt-16 bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-8 lg:p-12 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-white">
              <h3 className="text-2xl sm:text-3xl font-bold mb-3">
                {videoSection.title}
              </h3>
              <p className="text-gray-400 mb-6">
                {videoSection.description}
              </p>
              {videoSection.videoUrl && (
                <button 
                  onClick={() => window.open(videoSection.videoUrl, '_blank')}
                  className="bg-red-500 hover:bg-red-600 text-white px-6 py-3 rounded-full font-semibold transition"
                >
                  Watch Video
                </button>
              )}
            </div>
            <div className="w-full lg:w-96 h-56 bg-gray-700 rounded-2xl flex items-center justify-center cursor-pointer group relative overflow-hidden">
              <img
                src={videoSection.thumbnailUrl || "https://cdn.corporatefinanceinstitute.com/assets/real-estate.jpeg"}
                alt={videoSection.title}
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/30 transition">
                <div className="w-16 h-16 bg-red-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                  <span onClick={() => window.open(videoSection.videoUrl, '_blank')} className="text-white text-2xl ml-1">▶</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default MediaCoverage;
